module.exports = __webpack_public_path__ + "img/motorway_4x1.f3fb58a8.svg";